var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { ClassBaseDirective } from '../base/classbase.directive';
import { ClassService } from '../../service/class.service';
var ItemSubItemDirective = /** @class */ (function (_super) {
    __extends(ItemSubItemDirective, _super);
    function ItemSubItemDirective(el, renderer, service) {
        var _this = _super.call(this, el, renderer, service) || this;
        _this.el = el;
        _this.renderer = renderer;
        _this.service = service;
        _this.err_p = _this.renderer.createElement('p');
        _this.err_p_price = _this.renderer.createElement('p');
        return _this;
    }
    ItemSubItemDirective.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    ItemSubItemDirective.prototype.onInit = function () {
    };
    ItemSubItemDirective.prototype.addRequiredError = function (errFlg, msg) {
        var element = this.el.nativeElement.querySelector('.subitemRequiredError');
        var el = element.querySelector('.formError');
        if (errFlg) {
            if (!el) {
                this.err_text = this.renderer.createText(msg);
                this.renderer.addClass(this.err_p, 'formError');
                this.renderer.appendChild(this.err_p, this.err_text);
                this.renderer.appendChild(element, this.err_p);
            }
        }
        else {
            if (el) {
                this.renderer.removeChild(this.err_p, this.err_text);
                this.renderer.removeChild(element, this.err_p);
            }
        }
    };
    ItemSubItemDirective.prototype.addPriceError = function (errFlg, msg) {
        var element = this.el.nativeElement.querySelector('.subitemPriceError');
        var el = element.querySelector('.formError');
        if (errFlg) {
            if (!el) {
                this.err_text_price = this.renderer.createText(msg);
                this.renderer.addClass(this.err_p_price, 'formError');
                this.renderer.appendChild(this.err_p_price, this.err_text_price);
                this.renderer.appendChild(element, this.err_p_price);
            }
        }
        else {
            if (el) {
                this.renderer.removeChild(this.err_p_price, this.err_text_price);
                this.renderer.removeChild(element, this.err_p_price);
            }
        }
    };
    ItemSubItemDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[subitemDir]'
                },] }
    ];
    /** @nocollapse */
    ItemSubItemDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ClassService }
    ]; };
    return ItemSubItemDirective;
}(ClassBaseDirective));
export { ItemSubItemDirective };
//# sourceMappingURL=item-subitem.directive.js.map